import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class NotificationService {

    constructor(private toasterService: ToastrService, private translate: TranslateService) {
    }

    open(message: string, level = 'success') {
        switch (level) {
            case 'success':
                this.toasterService.success(this.translate.instant(message));
                break;
            case 'error':
                this.toasterService.error(this.translate.instant(message));
                break;
            default:
                this.toasterService.info(this.translate.instant(message));
        }
    }
}
